/**
 * Registre des titres / succès.
 * Chaque titre a un identifiant, un nom, une icône optionnelle, un flag secret,
 * des conditions et des récompenses.
 */

export const TITLES = {
  // --- Triviaux / Débutants (8) ---
  first_blood: {
    id: 'first_blood', name: 'Premier Sang', icon: '🩸',
    img: '/assets/titles/icons/blood-splatter.svg', secret: false,
    desc: 'Tuer votre première créature.',
    conditions: { type: 'kill', target: 'any', count: 1 },
    rewards: { stats: { DEX: 1 }, title: true }
  },
  slime_stomper: {
    id: 'slime_stomper', name: 'Marcheur de Slimes', icon: '💧',
    img: '/assets/titles/icons/slime.svg', secret: false,
    desc: 'Écraser 3 slimes. Qui savait que c\'était si facile ?',
    conditions: { type: 'kill', target: 'm_slime', count: 3 },
    rewards: { stats: { VIT: 1 }, title: true }
  },
  novice_explorer: {
    id: 'novice_explorer', name: 'Explorateur Novice', icon: '🧭',
    img: '/assets/titles/icons/compass.svg', secret: false,
    desc: 'Atteindre le niveau 5.',
    conditions: { type: 'level', target: 'any', count: 5 },
    rewards: { stats: { PV: 10 }, title: true }
  },
  first_quest: {
    id: 'first_quest', name: 'Première Quête', icon: '📜',
    img: '/assets/titles/icons/scroll-unfurled.svg', secret: false,
    desc: 'Terminer votre première quête.',
    conditions: { type: 'questCompleted', target: 'any', count: 1 },
    rewards: { stats: { CHA: 1 }, title: true }
  },
  apprentice: {
    id: 'apprentice', name: 'Apprenti', icon: '📚',
    img: '/assets/titles/icons/book.svg', secret: false,
    desc: 'Atteindre le niveau 10.',
    conditions: { type: 'level', target: 'any', count: 10 },
    rewards: { stats: { INT: 2, SAG: 1 }, title: true }
  },
  first_duel: {
    id: 'first_duel', name: 'Premier Duel', icon: '⚔️',
    img: '/assets/titles/icons/crossed-swords.svg', secret: false,
    desc: 'Gagner votre premier duel.',
    conditions: { type: 'duelWon', target: 'any', count: 1 },
    rewards: { stats: { DEX: 1, CHA: 1 }, title: true }
  },
  penny_pincher: {
    id: 'penny_pincher', name: 'Cuivres Comptés', icon: '🪙',
    img: '/assets/titles/icons/coins.svg', secret: false,
    desc: 'Gagner 500 cuivres au total.',
    conditions: { type: 'goldEarned', target: 'any', count: 500 },
    rewards: { stats: { CHA: 1 }, title: true }
  },
  pack_hunter: {
    id: 'pack_hunter', name: 'Chasseur de Meutes', icon: '👥',
    img: '/assets/titles/icons/torch.svg', secret: false,
    desc: 'Participer à votre premier événement.',
    conditions: { type: 'eventParticipated', target: 'any', count: 1 },
    rewards: { stats: { VIT: 1 }, title: true }
  },

  // --- Faciles (10) ---
  slime_squisher: {
    id: 'slime_squisher', name: 'Écraseur de Slimes', icon: '💧',
    img: '/assets/titles/icons/slime.svg', secret: false,
    desc: '100 slimes réduits en flaque.',
    conditions: { type: 'kill', target: 'm_slime', count: 100 },
    rewards: { stats: { VIT: 2 }, unlockShop: ['slime_basher'], title: true, effect: { vsMonster: 'm_slime', dmgMult: 1.10 } }
  },
  goblin_slayer: {
    id: 'goblin_slayer', name: 'Chasseur de Gobelins', icon: '👺',
    img: '/assets/titles/icons/goblin.svg', secret: false,
    desc: '50 gobelins vaincus.',
    conditions: { type: 'kill', target: 'm_gobelin', count: 50 },
    rewards: { stats: { FOR: 2 }, title: true }
  },
  bone_breaker: {
    id: 'bone_breaker', name: 'Briseur d\'Os', icon: '💀',
    img: '/assets/titles/icons/skull.svg', secret: false,
    desc: '30 squelettes dispersés.',
    conditions: { type: 'kill', target: 'm_squelette', count: 30 },
    rewards: { stats: { FOR: 2 }, title: true }
  },
  zombie_hunter: {
    id: 'zombie_hunter', name: 'Chasseur de Zombies', icon: '🧟',
    img: '/assets/titles/icons/raise-zombie.svg', secret: false,
    desc: '25 zombies remis en terre.',
    conditions: { type: 'kill', target: 'm_zombie', count: 25 },
    rewards: { stats: { PV: 10 }, title: true }
  },
  hunter: {
    id: 'hunter', name: 'Chasseur', icon: '🏹',
    img: '/assets/titles/icons/bow.svg', secret: false,
    desc: 'Tuer 50 créatures au total.',
    conditions: { type: 'totalKills', target: 'any', count: 50 },
    rewards: { stats: { DEX: 2 }, title: true }
  },
  healer_apprentice: {
    id: 'healer_apprentice', name: 'Soigneur', icon: '💚',
    img: '/assets/titles/icons/health-potion.svg', secret: false,
    desc: 'Soigner 500 PV au total.',
    conditions: { type: 'totalHeal', target: 'any', count: 500 },
    rewards: { stats: { SAG: 2 }, title: true }
  },
  merchant: {
    id: 'merchant', name: 'Marchand', icon: '💰',
    img: '/assets/titles/icons/coins.svg', secret: false,
    desc: 'Gagner 5000 cuivres.',
    conditions: { type: 'goldEarned', target: 'any', count: 5000 },
    rewards: { stats: { CHA: 2 }, title: true }
  },
  quest_adventurer: {
    id: 'quest_adventurer', name: 'Aventurier', icon: '🗺️',
    img: '/assets/titles/icons/map.svg', secret: false,
    desc: 'Terminer 10 quêtes.',
    conditions: { type: 'questCompleted', target: 'any', count: 10 },
    rewards: { stats: { DEX: 2, CHA: 1 }, title: true }
  },
  fletchling_stomper: {
    id: 'fletchling_stomper', name: 'Chasseur de Fletchlings', icon: '🐦',
    img: '/assets/titles/icons/bird.svg', secret: false,
    desc: '20 fletchlings pourchassés.',
    conditions: { type: 'kill', target: 'm_fletchling', count: 20 },
    rewards: { stats: { DEX: 3 }, title: true }
  },
  brutos_slayer: {
    id: 'brutos_slayer', name: 'Pourfendeur de Brutos', icon: '🦝',
    img: '/assets/titles/icons/boar.svg', secret: false,
    desc: '30 brutos terrassés.',
    conditions: { type: 'kill', target: 'm_brutos', count: 30 },
    rewards: { stats: { FOR: 2, VIT: 1 }, title: true }
  },

  // --- Moyens (12) ---
  demon_slayer: {
    id: 'demon_slayer', name: 'Demon\'s Slayer', icon: '🔥',
    img: '/assets/titles/icons/demon.svg', secret: true,
    desc: '100 gobelins exterminés. Les démons mineurs tremblent.',
    conditions: { type: 'kill', target: 'm_gobelin', count: 100 },
    rewards: { stats: { FOR: 3 }, unlockShop: ['goblin_cleaver', 'goblin_hunter_hood'], title: true, effect: { vsMonster: 'm_gobelin', dmgMult: 1.10 } }
  },
  goblin_punching_bag: {
    id: 'goblin_punching_bag', name: 'Sac à Gobelins', icon: '🥊',
    img: '/assets/titles/icons/shield.svg', secret: true,
    desc: '1000 dégâts de gobelins encaissés.',
    conditions: { type: 'damageTaken', target: 'm_gobelin', count: 1000 },
    rewards: { stats: { ARMURE: 5 }, unlockShop: ['goblin_resistant_plate'], title: true, effect: { vsMonster: 'm_gobelin', dmgReduction: 0.10 } }
  },
  mummy_hunter: {
    id: 'mummy_hunter', name: 'Chasseur de Momies', icon: '🧻',
    img: '/assets/titles/icons/mummy.svg', secret: false,
    desc: '20 momies démaillées.',
    conditions: { type: 'kill', target: 'm_momie', count: 20 },
    rewards: { stats: { SAG: 3 }, title: true }
  },
  harpy_slayer: {
    id: 'harpy_slayer', name: 'Chasseur d\'Harpies', icon: '🦅',
    img: '/assets/titles/icons/harpy.svg', secret: false,
    desc: '30 harpies désagrégées.',
    conditions: { type: 'kill', target: 'm_harpye', count: 30 },
    rewards: { stats: { DEX: 3 }, title: true, effect: { vsMonster: 'm_harpye', dmgMult: 1.10 } }
  },
  veteran: {
    id: 'veteran', name: 'Vétéran', icon: '🎖️',
    img: '/assets/titles/icons/medal.svg', secret: false,
    desc: 'Atteindre le niveau 25.',
    conditions: { type: 'level', target: 'any', count: 25 },
    rewards: { stats: { FOR: 3, INT: 3, SAG: 3 }, title: true }
  },
  duelist: {
    id: 'duelist', name: 'Duelliste', icon: '⚔️',
    img: '/assets/titles/icons/rapier.svg', secret: false,
    desc: 'Gagner 15 duels.',
    conditions: { type: 'duelWon', target: 'any', count: 15 },
    rewards: { stats: { DEX: 3, CHA: 2 }, unlockShop: ['duelist_gauntlets'], title: true }
  },
  event_veteran: {
    id: 'event_veteran', name: 'Vétéran des Événements', icon: '🎪',
    img: '/assets/titles/icons/flag.svg', secret: false,
    desc: 'Participer à 10 événements.',
    conditions: { type: 'eventParticipated', target: 'any', count: 10 },
    rewards: { stats: { CHA: 3 }, title: true }
  },
  murmure_friend: {
    id: 'murmure_friend', name: 'Ami des Murmures', icon: '👻',
    img: '/assets/titles/icons/ghost.svg', secret: false,
    desc: '50 murmures apaisés.',
    conditions: { type: 'kill', target: 'm_murmure', count: 50 },
    rewards: { stats: { SAG: 3, CHA: 2 }, title: true }
  },
  cuirgeant_tamer: {
    id: 'cuirgeant_tamer', name: 'Dresseur de Cuirgéants', icon: '🦬',
    img: '/assets/titles/icons/caterpillar.svg', secret: false,
    desc: '10 cuirgéants calmés.',
    conditions: { type: 'kill', target: 'm_cuirgéant', count: 10 },
    rewards: { stats: { VIT: 3, ARMURE: 3 }, title: true }
  },
  troll_slayer: {
    id: 'troll_slayer', name: 'Tueur de Trolls', icon: '🧌',
    img: '/assets/titles/icons/troll.svg', secret: false,
    desc: '15 trolls vaincus.',
    conditions: { type: 'kill', target: 'm_troll', count: 15 },
    rewards: { stats: { FOR: 4 }, unlockShop: ['troll_slayer_mace'], title: true }
  },
  wyvern_hunter: {
    id: 'wyvern_hunter', name: 'Chasseur de Wyverns', icon: '🐉',
    img: '/assets/titles/icons/wyvern.svg', secret: false,
    desc: '10 wyverns abattus.',
    conditions: { type: 'kill', target: 'm_wyvern', count: 10 },
    rewards: { stats: { DEX: 4, FOR: 2 }, unlockShop: ['wyvern_piercer'], title: true }
  },
  healer_master: {
    id: 'healer_master', name: 'Maître Soigneur', icon: '💚',
    img: '/assets/titles/icons/health-potion.svg', secret: false,
    desc: 'Soigner 5000 PV au total.',
    conditions: { type: 'totalHeal', target: 'any', count: 5000 },
    rewards: { stats: { SAG: 5 }, title: true }
  },

  // --- Difficiles (12) ---
  dragon_slayer: {
    id: 'dragon_slayer', name: 'Tueur de Dragons', icon: '🐉',
    img: '/assets/titles/icons/dragon-head.svg', secret: false,
    desc: '3 dragons anciens terrassés.',
    conditions: { type: 'kill', target: 'm_dragon', count: 3 },
    rewards: { stats: { FOR: 8, CHA: 5 }, unlockShop: ['dragon_slayer_blade', 'dragon_scale_armor'], title: true, effect: { vsMonster: 'm_dragon', dmgMult: 1.20 } }
  },
  chimera_bane: {
    id: 'chimera_bane', name: 'Fléau de Chimère', icon: '🦁',
    img: '/assets/titles/icons/chimera.svg', secret: true,
    desc: '5 chimères tombées.',
    conditions: { type: 'kill', target: 'm_chimere', count: 5 },
    rewards: { stats: { INT: 4, FOR: 4 }, unlockShop: ['chimera_fang_dagger'], title: true }
  },
  basilisk_slayer: {
    id: 'basilisk_slayer', name: 'Crépitator de Basilics', icon: '🦎',
    img: '/assets/titles/icons/basilisk.svg', secret: true,
    desc: '20 basilics pétrifiés.',
    conditions: { type: 'kill', target: 'm_basilic', count: 20 },
    rewards: { stats: { ARMURE: 5 }, title: true, effect: { vsMonster: 'm_basilic', dmgReduction: 0.10 } }
  },
  banshee_silencer: {
    id: 'banshee_silencer', name: 'Silencieuse de Banshee', icon: '👻',
    img: '/assets/titles/icons/ghost.svg', secret: true,
    desc: '25 plaintes étouffées.',
    conditions: { type: 'kill', target: 'm_banshee', count: 25 },
    rewards: { stats: { SAG: 4 }, title: true, effect: { vsMonster: 'm_banshee', magicDmgMult: 1.15 } }
  },
  wendigo_hunter: {
    id: 'wendigo_hunter', name: 'Chasseur de Wendigos', icon: '❄️',
    img: '/assets/titles/icons/wendigo.svg', secret: false,
    desc: '15 wendigos vaincus.',
    conditions: { type: 'kill', target: 'm_wendigo', count: 15 },
    rewards: { stats: { VIT: 4 }, title: true, effect: { vsMonster: 'm_wendigo', armorBonus: 5 } }
  },
  hydra_slayer: {
    id: 'hydra_slayer', name: 'Coupeur de Têtes', icon: '🐍',
    img: '/assets/titles/icons/hydra.svg', secret: true,
    desc: '5 hydres décapitées.',
    conditions: { type: 'kill', target: 'm_hydre', count: 5 },
    rewards: { stats: { FOR: 5 }, title: true, effect: { vsMonster: 'm_hydre', dmgMult: 1.15 } }
  },
  kraken_bane: {
    id: 'kraken_bane', name: 'Fléau des Profondeurs', icon: '🦑',
    img: '/assets/titles/icons/kraken.svg', secret: true,
    desc: '1 kraken ramené à la surface.',
    conditions: { type: 'kill', target: 'm_kraken', count: 1 },
    rewards: { stats: { FOR: 6, DEX: 4 }, title: true, effect: { vsMonster: 'm_kraken', dmgMult: 1.20 } }
  },
  phoenix_slayer: {
    id: 'phoenix_slayer', name: 'Maître du Feu', icon: '🔥',
    img: '/assets/titles/icons/phoenix.svg', secret: true,
    desc: '1 phénix vaincu avant renaissance.',
    conditions: { type: 'kill', target: 'm_phoenix', count: 1 },
    rewards: { stats: { INT: 6, VIT: 4 }, title: true, effect: { vsMonster: 'm_phoenix', magicDmgMult: 1.20 } }
  },
  lich_slayer: {
    id: 'lich_slayer', name: 'Pourfendeur de Roi-Liche', icon: '☠️',
    img: '/assets/titles/icons/lich.svg', secret: true,
    desc: '1 roi-liche renvoyé dans l\'oubli.',
    conditions: { type: 'kill', target: 'm_liche', count: 1 },
    rewards: { stats: { SAG: 5, INT: 5 }, title: true, effect: { vsMonster: 'm_liche', dmgMult: 1.20 } }
  },
  titan_bane: {
    id: 'titan_bane', name: 'Briseur de Titans', icon: '🗿',
    img: '/assets/titles/icons/titan.svg', secret: true,
    desc: '1 titan réduit en gravier.',
    conditions: { type: 'kill', target: 'm_titan', count: 1 },
    rewards: { stats: { FOR: 8, ARMURE: 5 }, title: true, effect: { vsMonster: 'm_titan', dmgMult: 1.20 } }
  },
  neant_challenger: {
    id: 'neant_challenger', name: 'Défi du Néant', icon: '🌑',
    img: '/assets/titles/icons/demon.svg', secret: true,
    desc: '1 Néant Incarné affronté.',
    conditions: { type: 'kill', target: 'm_néant', count: 1 },
    rewards: { stats: { INT: 8, FOR: 5 }, unlockShop: ['requiem_du_neant'], title: true }
  },
  legend: {
    id: 'legend', name: 'Légende de la Guilde', icon: '🏆',
    img: '/assets/titles/icons/trophy.svg', secret: false,
    desc: 'Atteindre le niveau 45.',
    conditions: { type: 'level', target: 'any', count: 45 },
    rewards: { stats: { FOR: 5, INT: 5, SAG: 5, DEX: 5, CHA: 5 }, title: true }
  },

  // --- Impossibles / Secrets (10) ---
  demon_lord_slayer: {
    id: 'demon_lord_slayer', name: 'Tueur de Seigneur Démon', icon: '👿',
    img: '/assets/titles/icons/demon.svg', secret: true,
    desc: '1 seigneur démon détrôné.',
    conditions: { type: 'kill', target: 'm_demon_lord', count: 1 },
    rewards: { stats: { FOR: 10, CHA: 5 }, title: true, effect: { vsMonster: 'm_demon_lord', dmgMult: 1.25 } }
  },
  fenrir_slayer: {
    id: 'fenrir_slayer', name: 'Gardien du Monde', icon: '🐺',
    img: '/assets/titles/icons/wolf.svg', secret: true,
    desc: 'Fenrir tenu à distance.',
    conditions: { type: 'kill', target: 'm_fenrir', count: 1 },
    rewards: { stats: { FOR: 12, DEX: 6 }, title: true, effect: { vsMonster: 'm_fenrir', dmgMult: 1.25 } }
  },
  archdemon_slayer: {
    id: 'archdemon_slayer', name: 'Ange Déchu des Démons', icon: '🔱',
    img: '/assets/titles/icons/demon.svg', secret: true,
    desc: 'L\'archidémon suprême vaincu.',
    conditions: { type: 'kill', target: 'm_archdemon', count: 1 },
    rewards: { stats: { FOR: 15, INT: 10, CHA: 10 }, title: true, effect: { vsMonster: 'm_archdemon', dmgMult: 1.30 } }
  },
  dragon_exterminator: {
    id: 'dragon_exterminator', name: 'Exterminateur de Dragons', icon: '🐉',
    img: '/assets/titles/icons/dragon-head.svg', secret: true,
    desc: '100 dragons anciens terrassés. Une légende parmi les légendes.',
    conditions: { type: 'kill', target: 'm_dragon', count: 100 },
    rewards: { stats: { FOR: 20, DEX: 10, CHA: 10 }, title: true }
  },
  master_of_guilds: {
    id: 'master_of_guilds', name: 'Maître des Guildes', icon: '👑',
    img: '/assets/titles/icons/kings-crown.svg', secret: true,
    desc: 'Atteindre le niveau 50.',
    conditions: { type: 'level', target: 'any', count: 50 },
    rewards: { stats: { FOR: 10, INT: 10, SAG: 10, DEX: 10, CHA: 10 }, unlockShop: ['master_aegis'], title: true }
  },
  invincible: {
    id: 'invincible', name: 'Invaincu', icon: '🛡️',
    img: '/assets/titles/icons/shield.svg', secret: true,
    desc: 'Gagner 30 duels sans aucune défaite.',
    conditions: { type: 'duelWon', target: 'any', count: 30 },
    rewards: { stats: { DEX: 10, CHA: 5, ARMURE: 10 }, title: true }
  },
  exterminator: {
    id: 'exterminator', name: 'Exterminateur', icon: '☠️',
    img: '/assets/titles/icons/skull.svg', secret: true,
    desc: 'Tuer 1000 créatures au total.',
    conditions: { type: 'totalKills', target: 'any', count: 1000 },
    rewards: { stats: { FOR: 10, DEX: 5, INT: 5 }, unlockShop: ['exterminator_blade'], title: true }
  },
  god_of_war: {
    id: 'god_of_war', name: 'Dieu de la Guerre', icon: '⚔️',
    img: '/assets/titles/icons/crossed-swords.svg', secret: true,
    desc: 'Gagner 500 duels.',
    conditions: { type: 'duelWon', target: 'any', count: 500 },
    rewards: { stats: { FOR: 15, DEX: 10, CHA: 10 }, title: true }
  },
  seigneur_insecte_slayer: {
    id: 'seigneur_insecte_slayer', name: 'Dompteur de la Mer Toxique', icon: '🪲',
    img: '/assets/titles/icons/beetle.svg', secret: true,
    desc: '1 Seigneur des Insectes vaincu.',
    conditions: { type: 'kill', target: 'm_seigneur_insecte', count: 1 },
    rewards: { stats: { FOR: 10, VIT: 8, ARMURE: 8 }, unlockShop: ['carapace_seigneur_insecte'], title: true }
  },
  true_hero: {
    id: 'true_hero', name: 'Le Vrai Héros', icon: '🌟',
    img: '/assets/titles/icons/star.svg', secret: true,
    desc: 'Tuer au moins 1 de chaque créature du bestiaire.',
    conditions: { type: 'killAll', target: 'any', count: 1 },
    rewards: { stats: { FOR: 8, INT: 8, SAG: 8, DEX: 8, CHA: 8 }, unlockShop: ['hero_crown'], title: true }
  },

  // --- Titres héroïques — RÉPONSE AUX ALERTES SOS (docs/heros-titres-panoplies.md) ---
  // Le « bonus » hors-jeu : répondre à une vraie alerte SOS et arriver sur place
  // (validé serveur). Récompensé en PROGRESSION/PRESTIGE (le fond civique cuivre
  // est désactivé). C'est ICI que l'archétype secouriste/urgentiste prend son
  // sens — une vraie intervention, pas un POI.
  bon_samaritain: {
    id: 'bon_samaritain', name: 'Bon Samaritain', icon: '🤝',
    secret: false,
    desc: 'Répondre à votre première alerte SOS et arriver sur place.',
    conditions: { type: 'civicIntervention', target: 'any', count: 1 },
    rewards: { stats: { CHA: 2, SAG: 1 }, title: true }
  },
  secouriste_1: {
    id: 'secouriste_1', name: 'Secouriste de la Guilde', icon: '✨',
    secret: false,
    desc: 'Répondre à 5 alertes SOS (arrivée sur place validée).',
    conditions: { type: 'civicIntervention', target: 'any', count: 5 },
    rewards: {
      title: true,
      stats: { SAG: 3, CHA: 2 },
      unlockShop: ['secouriste_hat_1', 'secouriste_top_1', 'secouriste_staff_1']
    }
  },
  // Paliers II/III — gardés par le RANG (niveau/xp) ET le nombre d'interventions
  // (« récompense selon rang + xp »). Conditions composées via op:'all'.
  secouriste_2: {
    id: 'secouriste_2', name: 'Secouriste Confirmé', icon: '💠',
    secret: false,
    desc: 'Répondre à 15 alertes SOS, au niveau 18+ (≈ rang C).',
    conditions: { op: 'all', conditions: [
      { type: 'civicIntervention', target: 'any', count: 15 },
      { type: 'level', target: 'any', count: 18 }
    ] },
    rewards: {
      title: true,
      stats: { SAG: 5, CHA: 3, PV: 15 },
      unlockShop: ['secouriste_hat_2', 'secouriste_top_2', 'secouriste_staff_2']
    }
  },
  secouriste_3: {
    id: 'secouriste_3', name: 'Ange Gardien de la Guilde', icon: '🕊️',
    secret: false,
    desc: 'Répondre à 30 alertes SOS, au niveau 35+ (≈ rang A).',
    conditions: { op: 'all', conditions: [
      { type: 'civicIntervention', target: 'any', count: 30 },
      { type: 'level', target: 'any', count: 35 }
    ] },
    rewards: {
      title: true,
      stats: { SAG: 8, CHA: 6, PV: 30, RM: 5 },
      unlockShop: ['secouriste_hat_3', 'secouriste_top_3', 'secouriste_staff_3']
    }
  },
  // --- Donjons v2 (MAJ-08 P6) : gloire des finisseurs et des bâtisseurs ---
  dungeon_conqueror: {
    id: 'dungeon_conqueror', name: 'Conquérant de Donjon', icon: '🏆',
    secret: false,
    desc: 'Conquérir un donjon jusqu\'à son sommet.',
    conditions: { type: 'dungeonCleared', target: 'any', count: 1 },
    rewards: { title: true, stats: { PV: 20, FOR: 3 } }
  },
  dungeon_architect: {
    id: 'dungeon_architect', name: 'Architecte de Donjon', icon: '📐',
    secret: false,
    desc: 'Votre donjon de clan a été conquis par 10 aventuriers.',
    conditions: { type: 'dungeonBuilt', target: 'any', count: 10 },
    rewards: { title: true, stats: { INT: 4, CHA: 4 } }
  }
};

export function getTitleById(id: string) {
  return (TITLES as Record<string, any>)[id] || null;
}

export function listTitles() {
  return Object.values(TITLES);
}
